module.exports = __webpack_public_path__ + "img/master-card.fb08e0f8.svg";